import * as Yup from 'yup'
import { parse } from 'date-fns'

const VALIDATE_FORM = process.env.REACT_APP_VALIDATE_FORM || true

function parseDateString(value, originalValue) {
    var date = parse(originalValue, 'MM-dd-yyyy', new Date())
    if (!(date instanceof Date && !isNaN(date))) {
        // date invalid
        return undefined
    }
    return originalValue
}

const ClientValidation = Yup.object().shape({
    firstName: Yup.string()
        .min(2, 'Too Short!')
        .max(50, 'Too Long!')
        .required('First Name Required'),
    lastName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Last Name Required'),
    dob: Yup.string()
        .transform(parseDateString)
        .required('Enter Date of Birth in MM-DD-YYYY format'),

    // dob: Yup.date().transform(parseDateString).required('Date of Birth Required'),
    annualBaseIncome: Yup.string().required('Enter Base Income'),
    taxBracket: Yup.string(),
    retirementAge: Yup.string().required('Enter Value'),
})

const GroupCoverageValidation = Yup.object().shape({
    percentCovered: Yup.string().required('Enter Value'),
    waitingPeriod: Yup.string().required('Choose a Value'),
    monthlyMaximum: Yup.string().required('Enter Value'),
    benefitPeriod: Yup.string().required('Choose a Value'),
    annualPremium: Yup.string().required('Enter Value'),
})

const GroupStdCoverageValidation = Yup.object().shape({
    percentCovered: Yup.string().required('Enter Value'),
    waitingPeriod: Yup.string().required('Choose a Value'),
    weeklyMaximum: Yup.string().required('Enter Value'),
    benefitPeriod: Yup.string().required('Choose a Value'),
    annualPremium: Yup.string().required('Enter Value'),
})

const IndividualCoverageValidation = Yup.object().shape({
    benefitAmount: Yup.string().required('Enter Base Income'),
    monthlyMaximum: Yup.string().required('Choose Monthly Maximum/Cap'),
    waitingPeriod: Yup.string().required('Enter Value'),
    benefitPeriod: Yup.string().required('Enter Value'),
    cola: Yup.string().required('Enter Value'),
    futureIncrease: Yup.string().required('Enter Value'),
    annualPremium: Yup.string().required('Enter Value'),
    taxableBenefits: Yup.string().required('Enter Value'),
})

const InsuredAssetValidation = Yup.object().shape({
    estimatedValue: Yup.string(),
    annualInsuranceCost: Yup.string(),
})

const ProtectionValidation = Yup.object().shape({
    benefitAmount: Yup.string(),
    monthlyMaximum: Yup.string(),
    benefitPeriod: Yup.string(),
    eliminationPeriod: Yup.string(),
    cola: Yup.string(),
    annualBenefitIncrease: Yup.string(),
    annualPremium: Yup.string(),
    monthlyPremium: Yup.string(),
    taxableBenefits: Yup.string(),
    catastrophicBenefitAmount: Yup.string(),
})

let ValidationSchema = Yup.object().shape({
    client: ClientValidation,
    coverage: Yup.object().shape({
        groupCoverages: Yup.array().of(GroupCoverageValidation),
        individualCoverages: Yup.array().of(IndividualCoverageValidation),
        groupStdCoverages: Yup.array().of(GroupStdCoverageValidation),
    }),
    protections: Yup.object().shape({
        basic: ProtectionValidation,
        moderate: ProtectionValidation,
        comprehensive: ProtectionValidation,
    }),
})

if (VALIDATE_FORM === 'false') {
    ValidationSchema = Yup.object()
}

export default ValidationSchema
